export const stateReservation = {
  PENDING: 'Reserva pendiente de pago', //En estado de pago
  PAID_OUT: 'Reserva pagada',
  REFUND_PROCESSING: 'Reembolso en proceso',
  REFUND_ACCEPTED: 'Reembolsado',
  REFUND_REJECTED: 'Reembolso rechazado',
  RE_SCHEDULE: 'Reserva reagendada',
  CANCEL: 'Reserva cancelada',
}

export const statePayments = {
  DEAL: 'Deal',
  PAYMENT_PROCESSING: 'Pago en proceso',
  PAYMENT_SUCCESS: 'Pago realizado',
  PAYMENT_REJECTED: 'Pago rechazado',
  PARTIAL_PAYMENT: 'Pago parcial realizado',
  DEFERRED_PAYMENT: 'Pago diferido',
}

export const stateOrder = {
  CREATED: 'Orden creada',
  RECEIVED: 'Orden recibida',
  PREPARING: 'Orden en preparacion',
  READY_TO_DELIVER: 'Lista para Despacho',
  ON_THE_WAY: 'En camino',
  DELIVERED: 'Entregada',
  REJECTED: 'Rechazada',
}

export const accountState = {
  CREATING: 'Creando cuenta',
  CREATED: 'Cuenta creada',
  DEACTIVATED: 'Cuenta desactivada',
}

export const typeRoom = {
  PRIVATE: 'Privada',
  SHARED: 'Compartida',
}

export const typeAccess = {
  PRIVATE: 'Privado',
  SHARED: 'Compartido',
}

export const outsideCategories = {
  CAMPING: 'Camping',
}

export const insideCategories = {
  BEDANDBREAKFAST: 'Bed and Breakfast',
  APARTMENT: 'Apartamento',
  HOSTEL: 'Hostel',
  HOUSE: 'Casa',
  UNIQUEAPARTMENT: 'Apartamento Unico',
  BOUTIQUE: 'Hotel Boutique',
  ANNEXHOUSE: 'Vivienda Anexa',
}

export const hotelCategory = {
  OUTSIDE: 'Aire libre',
  INSIDE: 'Interior',
}

export const heyAndesStatus = {
  PAID_OUT: 'Pagado',
  OUTSTANDING: 'Pendiente de pago',
  NOT_PAYED: 'No pagado',
  REFUND: 'Reembolsado',
}
